import Vue from 'vue';
import Vuex, { StoreOptions, Store } from 'vuex';
import { RootState } from './types.d';
import * as globalTypes from './modules/global/mutations-types'
Vue.use(Vuex);

import { globalState } from './modules/global';
import { vasState } from './modules/vas';

const cartChangeListner = (store: Store<RootState>) => {
  // called when the store is initialized
  store.subscribe(({ type, payload }: any, state) => {
    if (type === `global/${globalTypes.setCart}`) {
      store.dispatch('vas/restoreFromCart', payload)
    }
  })
}

const rootStore: StoreOptions<RootState> = {
  modules: {
    global: globalState,
    vas: vasState
  },
  plugins: [cartChangeListner]
};

const store = new Vuex.Store<RootState>(rootStore);

export default store;